module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0088.jpg?v=db7cbbc6";